import { EditTimelineForm } from 'components/timelines/actions/edit_timeline_form'
import { useSanitiseTimelineHtml } from 'hooks/timelines/use_sanitise_timeline_html'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { makeGetNote } from '../../../reduxes/slices/api/selectors'
import { getSelectedTimelineId } from '../../../reduxes/slices/selected/selectors'
import Timeline from '../timeline'

export default function Note({ timeline }) {
  const getNote = useMemo(makeGetNote, [])
  const note = useSelector((state) => getNote(state, timeline?.tl_id))
  const selectedTimelineId = useSelector(getSelectedTimelineId)
  const showEditor = selectedTimelineId === timeline?.id

  const noteHtml = useSanitiseTimelineHtml(note)

  if (!timeline || !note) return null

  const isDeleted = !!note?.deleted_at

  return (
    <Timeline
      timeline={timeline}
      item={note}
      handle={note.handle}
      align={'left'}
      withActionsBar={!isDeleted}
      withEmojiReactions={!isDeleted}
    >
      <div className={'note align-left'}>
        {showEditor ? (
          <EditTimelineForm timeline={timeline} item={note} />
        ) : (
          <div
            className={'content'}
            dangerouslySetInnerHTML={{ __html: noteHtml }}
          />
        )}
      </div>
    </Timeline>
  )
}

Note.propTypes = {
  timeline: PropTypes.object.isRequired,
}
